import { useNavigate } from "react-router-dom";
import { ChevronRight, CalendarClock, Layers, Pencil } from "lucide-react";

export default function LectorCard({ lector, onEdit }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={`lector-card-${lector.id}`}
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/lector/${lector.id}`)}
      className="relative text-left border border-border rounded-lg p-5 bg-card hover:shadow-sm hover:border-foreground/20 transition-all group cursor-pointer"
    >
      {onEdit && (
        <button
          data-testid={`lector-edit-${lector.id}`}
          onClick={(e) => { e.stopPropagation(); onEdit(lector); }}
          className="absolute top-3 right-3 p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary"
          title="Upravit lektora"
        >
          <Pencil className="h-4 w-4" />
        </button>
      )}
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-primary text-primary-foreground grid place-items-center font-heading font-semibold">
          {(lector.name || "?").charAt(0)}
        </div>
        <div>
          <div className="font-medium">{lector.name}</div>
          <div className="text-xs text-muted-foreground">{lector.email}</div>
        </div>
      </div>
      <div className="flex gap-4 mt-4 text-sm items-center">
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <CalendarClock className="h-4 w-4" /> {lector.upcoming_count} nadcházející
        </span>
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <Layers className="h-4 w-4" /> {lector.total_count} celkem
        </span>
        <ChevronRight className="h-4 w-4 text-muted-foreground ml-auto group-hover:translate-x-0.5 transition-transform" />
      </div>
    </div>
  );
}
